import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { HIGH_FIVES_ENABLED } from '../constants/api';

/** When High Fives is disabled (e.g. Production build), redirects to dashboard instead of rendering children. */
export const HighFivesFeatureGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!HIGH_FIVES_ENABLED) {
      navigate('/dashboard/my', { replace: true, state: { from: location.pathname } });
    }
  }, [navigate, location.pathname]);

  if (!HIGH_FIVES_ENABLED) {
    return null;
  }

  return <>{children}</>;
};

export default HighFivesFeatureGate;
